import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  root: {
    padding: 0,

    '& .MuiPaper-root': {
      width: '100%',
    },
  },

  form: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    padding: spacing(40),
    gap: spacing(26),
  },

  select: {
    width: '100%',
    margin: 0,
    height: '100% !important',
    '& .MuiFormLabel-root': {
      fontSize: `${spacing(18)} !important`,
    },
  },
}))
